import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, watch } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //答案
    let answer = reactive([]);
    watch(props, () => {
      let list = [];
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach((questionItem, i) => {
          if (props.allAnswers[questionItem.questionId]) {
            list[props.allAnswers[questionItem.questionId] - 1] = i + 1;
          }
          // list[i] =
          //   props.allAnswers && props.allAnswers[questionItem.questionId]
          //     ? props.allAnswers[questionItem.questionId] * 1
          //     : "";
        });
      });
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question")[0].scrollTop = 0;
    });
    function setAnswer() {
      let data = {};
      props.questionInfo.questionGroupList[0].questionList.forEach(item => {
        data[item.questionId] = "";
      });
      for (let i = 0; i < answer.length; i++) {
        if (answer[i]) {
          data[props.questionInfo.questionGroupList[0].questionList[answer[i] - 1].questionId] = i - 0 + 1 + "";
        }
      }
      // props.questionInfo.questionGroupList[0].questionList.forEach(
      //   (item, i) => {
      //     data[item.questionId] = answer[i];
      //   }
      // );
      console.log(data);
      content.emit("setAnswer", data);
    }
    return {
      answer,
      setAnswer
    };
  }
};